import { useContent } from "@/context/ContentContext";
import Navbar from "./Navbar";
import HeroSection from "./HeroSection";
import ActivitiesSection from "./ActivitiesSection";
import ScheduleSection from "./ScheduleSection";
import PricingSection from "./PricingSection";
import RegistrationForm from "./RegistrationForm";
import Footer from "./Footer";
import MonitorsSection from "./MonitorsSection";
import ReviewsSection from "./ReviewsSection";
import FaqsSection from "./FaqsSection";
import FloatingActionButton from "./FloatingActionButton";
import SEOHead from "./SEOHead";

export default function LandingPage() {
  const { content, loading } = useContent();

  const general = content.general || {};
  const hero = content.hero || {};
  const activities = content.activities || [];
  const schedule = content.schedule || {};
  const pricing = content.pricing || {};
  const contact = content.contact || {};
  const seo = content.seo || {};
  const monitors_content = content.monitors || {};
  const form_config = content.form_config || {};

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ background: "#0072A4" }}>
        <div className="text-center text-white">
          <div className="text-6xl mb-4 bounce-slow">🏄</div>
      <p className="font-['Montserrat'] text-2xl font-bold">Cargando el campus...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen overflow-x-hidden">
      <SEOHead seo={seo} general={general} />
      <Navbar general={general} />
      <HeroSection hero={hero} general={general} />
      <ActivitiesSection activities={activities} />
      <ScheduleSection schedule={schedule} />
      <PricingSection pricing={pricing} general={general} />
      <MonitorsSection general={general} monitors_content={monitors_content} />
      <ReviewsSection />
      <FaqsSection />
      <RegistrationForm pricing={pricing} general={general} form_config={form_config} />
      <Footer contact={contact} general={general} />
      <FloatingActionButton whatsapp={general.whatsapp || "657871824"} />
    </div>
  );
}
